/**
 * The character length threshold at which a note is truncated when displayed (e.g., in list views or summary columns).
 */
export const truncatedNoteLength = 100;

/**
 * The maximum number of characters allowed in a text note.
 */
export const maxNoteLength = 500;

/**
 * Defines responsive drawer width breakpoints — each entry maps a named breakpoint to the maximum screen width it applies to and the corresponding drawer size (in viewport-width units).
 */
export const drawerWidthConfig = {
  xsmall: {
    maxScreenWidth: 600,
    size: '90vw'
  },
  small: {
    maxScreenWidth: 1050,
    size: '90vw'
  },
  medium: {
    maxScreenWidth: 1600,
    size: '50vw'
  },
  large: {
    maxScreenWidth: undefined,
    size: '30vw'
  }
};

/**
 * Mock tag data for development and testing — a list of placeholder tags with sequential keys and labels.
 */
export const mockTags = [
  {
    key: 1,
    name: 'Tag 1'
  },
  {
    key: 2,
    name: 'Tag 2'
  },
  {
    key: 3,
    name: 'Tag 3'
  },
  {
    key: 4,
    name: 'Tag 4'
  },
  {
    key: 5,
    name: 'Tag 5'
  }
];
